var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"mintitle-box-bg",style:({backgroundImage: `url(${require( '@/assets/comimg/'+ _vm.titlebg )})`})},_vm.$listeners),[_c('div',{staticClass:"mintitle-text",style:({color:_vm.titletextcolor})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }